// @ts-nocheck
import { FEATURE_REQUEST_FEEDBACK_ERROR, FEATURE_REQUEST_FEEDBACK_LOADING, FEATURE_REQUEST_FEEDBACK_SUCCESS} from "../Type";
import * as Authservices from '../../Services/services';

export const feature_request_feedback = (data) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch({
                type: FEATURE_REQUEST_FEEDBACK_LOADING,
                data: true
            })
            Authservices.feature_request_feedback(data).then((data) => {
                if (data?.status === 200) {
                    dispatch({
                        type: FEATURE_REQUEST_FEEDBACK_SUCCESS,
                        data: data?.data
                    })
                    return resolve(data?.data);
                }
            }).catch((error) => {
                if (error) {
                    dispatch({
                        type: FEATURE_REQUEST_FEEDBACK_ERROR,
                        data: {message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'}
                    })
                }
                return reject({message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'})
            })
        })
    }
}